// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HzEU","col":"styles_col__3i1Mj","actions":"styles_actions__sdkot","conflict":"styles_conflict__1zXB9"};